import { Component, inject, Input } from '@angular/core';
import { adminActions } from '../../../../../data-services/stores/actions/admin.actions';
import { Store } from '@ngrx/store';
import { selectAdminEvent } from '../../../../../data-services/stores/selectors/admin.selectors';
import { TableModule, TableRowCollapseEvent, TableRowExpandEvent } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { EventTicketComplete } from '../../../../../data-services/models/event-tickets/event-ticket-complete.model';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { AdminEditTicketComponent } from '../edit/feature/edit.component';
import { FaIconComponent } from "@fortawesome/angular-fontawesome";

@Component({
  selector: 'app-tickets-table',
  imports: [TableModule, ButtonModule, CommonModule, AdminEditTicketComponent, FaIconComponent],
  templateUrl: './table.component.html',
  styleUrl: './table.component.css'
})
export class TicketsTableComponent {
  @Input() ticketList?: EventTicketComplete[]


  expandedRows: { [key: number]: boolean } = {};
  editRow?: number;

  onClose(ticketId: number){
    delete this.expandedRows[ticketId]
  }
}
